import { ChakraBox, ChakraTooltip } from '@equip.health/ui';
import { type ReactNode, useState, useRef } from 'react';
import ProviderAvatarBlockTooltip from './ProviderAvatarBlockTooltip';

interface AvatarTooltipWrapperProps {
  actionTime?: string;
  children: React.ReactNode;
  isRoleAtAction?: boolean;
  onAvatarHover?: () => void;
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'bottom-start'
    | 'bottom-end'
    | 'top-start'
    | 'top-end'
    | 'right-start'
    | 'right-end'
    | 'left-start'
    | 'left-end';
  providerExternalId: string;
  shouldShowDisplayName?: boolean;
  tooltipLabel?: ReactNode;
}

const ProviderAvatarTooltipWrapper = ({
  actionTime,
  children,
  isRoleAtAction,
  onAvatarHover,
  placement,
  providerExternalId,
  shouldShowDisplayName,
  tooltipLabel,
}: AvatarTooltipWrapperProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const nameRef = useRef<HTMLDivElement | null>(null);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const handleNameMouseEnter = () => {
    onAvatarHover?.();
    setIsTooltipOpen(true);
  };
  const handleNameMouseLeave = () => {
    setTimeout(() => {
      if (
        !tooltipRef.current?.matches(':hover') &&
        !nameRef.current?.matches(':hover')
      ) {
        setIsTooltipOpen(false);
      }
    }, 100);
  };

  const handleTooltipMouseEnter = () => setIsTooltipOpen(true);
  const handleTooltipMouseLeave = () => setIsTooltipOpen(false);

  return (
    <ChakraBox pointerEvents="auto">
      <ChakraTooltip
        bg="white"
        borderRadius="8px"
        closeOnPointerDown={false}
        color="neutral.secondary"
        isOpen={isTooltipOpen && !!providerExternalId}
        label={
          <ChakraBox
            onMouseEnter={handleTooltipMouseEnter}
            onMouseLeave={handleTooltipMouseLeave}
            pointerEvents="auto"
            ref={tooltipRef}
          >
            {tooltipLabel ?? (
              <ProviderAvatarBlockTooltip
                actionTime={actionTime}
                isRoleAtAction={isRoleAtAction}
                providerExternalId={providerExternalId}
                shouldShowDisplayName={shouldShowDisplayName}
                TOP_LEVEL_ID="provider-avatar-tooltip"
              />
            )}
          </ChakraBox>
        }
        padding="12px"
        placement={placement}
        shouldWrapChildren
      >
        <ChakraBox
          onMouseEnter={handleNameMouseEnter}
          onMouseLeave={handleNameMouseLeave}
          ref={nameRef}
        >
          {children}
        </ChakraBox>
      </ChakraTooltip>
    </ChakraBox>
  );
};

export default ProviderAvatarTooltipWrapper;
